/**
 * Free/personal email providers that are not allowed to book a demo.
 * Mirrors the blocklist used on the public site (uptimerobot.com).
 * @see landing/src/assets/scripts/eventHandlers.js handleEnterpriseQuote()
 */
export const BLOCKED_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'icloud.com',
  'aol.com',
  'gmx.com',
  'yandex.com',
  '10minutemail.com',
  'mailinator.com',
  'guerrillamail.com',
];

export const BUSINESS_EMAIL_REQUIRED_MESSAGE =
  "Please use a business or professional email address. We don't accept addresses from this provider.";

/**
 * Returns true when the email's domain belongs to a free/personal provider.
 * An email with no domain (e.g. `foo@` or `foo`) is not considered "free" here —
 * empty input is handled separately by the form's required/empty check.
 */
export const isFreeEmailDomain = (email: string): boolean => {
  const domain = email.trim().toLowerCase().split('@')[1] || '';
  if (!domain) {
    return false;
  }
  return BLOCKED_EMAIL_DOMAINS.includes(domain);
};
